import script from "./ImageGalleryPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageGalleryPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ImageGalleryPopup.vue?vue&type=style&index=0&id=2e1277f5&lang=scss"

const __exports__ = script;

export default __exports__